import { useSyncExternalStore } from 'react';

// Tiny custom store — keeps Sprint 0 free of an extra state lib for a feature
// that's used in ~5 places. If toast usage grows, swap for Zustand (in deps).

export interface ToastItem {
  id: string;
  title?: string | undefined;
  description?: string | undefined;
  variant?: 'default' | 'success' | 'error' | undefined;
}

interface ToastStoreState {
  toasts: ToastItem[];
  dismiss: (id: string) => void;
}

let nextId = 0;
let state: ToastItem[] = [];
const listeners = new Set<() => void>();

function emit(): void {
  for (const l of listeners) l();
}

export function toast(item: Omit<ToastItem, 'id'>): string {
  const id = `toast-${++nextId}`;
  state = [...state, { id, ...item }];
  emit();
  return id;
}

function dismiss(id: string): void {
  state = state.filter((t) => t.id !== id);
  emit();
}

const subscribe = (cb: () => void): (() => void) => {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
};

const getSnapshot = (): ToastItem[] => state;

export function useToastStore<T>(selector: (s: ToastStoreState) => T): T {
  const snap = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  return selector({ toasts: snap, dismiss });
}
